import { render, staticRenderFns } from "./VesselView.vue?vue&type=template&id=487061fa&"
import script from "./VesselView.vue?vue&type=script&lang=js&"
export * from "./VesselView.vue?vue&type=script&lang=js&"
import style0 from "./VesselView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports